/** @jsxImportSource @emotion/react */
import { findAllPlatforms_findAllPlatforms_items as Platform } from '__generatedTypes__/findAllPlatforms'
import { EmailTemplateTypeEnum } from '__generatedTypes__/globalTypes'
import { SeparateEmail } from '../SeparateEmail'

type Props = {
  platform: Platform
}

export const SubscriptionPaymentFailed = ({ platform }: Props) => (
  <SeparateEmail
    memberEmailType={EmailTemplateTypeEnum.PaymentFailed}
    adminEmailType={EmailTemplateTypeEnum.PaymentFailedAdmin}
    platformId={platform.id}
  />
)
